import { FETCH_DASHBOARD_SUMMARY, LOG_OUT_USER } from "../../actions/actionTypes";


const dashboardSummaryReducer = (state={}, action) => {
    let summary = state;
    if (action && action.payload && action.payload.summary && !action.payload.errors && action.type === FETCH_DASHBOARD_SUMMARY){
         summary = action.payload.summary;
    }else if (action.type === LOG_OUT_USER){
        summary = {};
    }

    
    return summary;
}

export default dashboardSummaryReducer;